import { UK_POSTAL_CODE_REGEX } from '../../../constants/constants';

const collectionsDefaultsForm = {
  formId: 'collectionsDefaultsForm',
  formField: {
    destinationCountry: {
      props: {
        name: 'destinationCountry',
        label: 'Destination country',
        type: 'select',
        displayField: 'name',
      },
    },
    totalVolumetricWeight: {
      props: {
        name: 'totalVolumetricWeight',
      },
      value: 0.0,
    },
    weight: {
      props: {
        name: 'weight',
        label: 'Weight (kg)',
        type: 'number',
        placeholder: 'Select',
        inputProps: {
          min: 0,
          max: 999,
        },
      },
      validation: {
        name: 'weight',
        validationType: 'number',
        validations: [
          {
            type: 'min',
            params: [0.1, 'Weight is outside permitted range'],
          },
          {
            type: 'max',
            params: [999, 'Weight is outside permitted range'],
          },
        ],
      },
    },

    deliveryType: {
      props: {
        name: 'deliveryType',
        label: 'Delivery type:',
        type: 'radio',
      },
    },
    doorStepInstructions: {
      props: {
        name: 'doorStepInstructions',
        label: 'Doorstep instructions',
        type: 'select',
        displayField: 'name',
      },
    },
    deliveryServicePoint: {
      props: {
        name: 'deliveryServicePoint',
        label: 'Find service point',
        type: 'text',
        placeholder: 'Find ServicePoint ',
      },
      validation: {
        name: 'postalCode',
        validationType: 'string',
        validations: [
          {
            type: 'when',
            params: [
              'deliveryType',
              (deliveryType, schema) => {
                return deliveryType === 'deliverToServicePoint'
                  ? schema.required('ServicePoint  is required')
                  // .matches(UK_POSTAL_CODE_REGEX, 'Invalid postal code')
                  : schema.notRequired();
              },
            ],
          },
        ],
      },
    },
    leaveSafeLocation: {
      props: {
        name: 'leaveSafeLocation',
        label: 'Leave safe location',
        type: 'text',
        placeholder: 'Leave Safe location',
      },
    },
    exchange: {
      props: {
        name: 'exchange',
        label: 'Exchange on delivery:',
        type: 'radio',
      },
    },
    specialInstructions: {
      props: {
        name: 'specialInstructions',
        label: 'Special instructions',
        type: 'text',
        inputProps: {
          maxLength: 30,
        },
      },
      validation: {
        name: 'specialInstructions',
        validationType: 'string',
        validations: [{
          type: 'max',
          params: [30, 'Max 30 characters are allowed'],
        }],
      },
    },
    additionalInstruction: {
      props: {
        name: 'additionalInstruction',
        type: 'text',
        inputProps: {
          maxLength: 30,
        },
      },
    },

    service: {
      props: {
        name: 'service',
        label: 'Service',
        type: 'select',
        displayField: 'name',
      },
    },

    noOfItems: {
      props: {
        name: 'noOfItems',
        label: 'Number of parcels',
        type: 'number',
        inputProps: {
          min: 1,
          max: 20,
        },
        restrictDecimal: true
      },
      validation: {
        name: 'noOfItems',
        validationType: 'number',
        validations: [
          {
            params: [1, 'Number of parcels must be between 1 and 200.'],
            type: 'min',
          },
          {
            type: 'max',
            params: [200, 'Number of parcels must be between 1 and 200.'],
          },
        ],
      },
    },

    collectionInstructions: {
      props: {
        name: 'collectionInstructions',
        label: 'Collection instructions',
        type: 'text',
        inputProps: {
          maxLength: 60,
        },
      },
    },
    descriptionOfGoods: {
      props: {
        name: 'descriptionOfGoods',
        label: 'Description of goods to be collected',
        type: 'text',
        inputProps: {
          maxLength: 50,
        },
      },
    },
    defaultCollectionAccounts: {
      props: {
        name: 'defaultCollectionAccounts',
        label: 'Default collection account',
        type: 'select',
        displayId: "accountId",
        displayField: 'accountName',
        hasDefaultValue: false,
      },

    },
    shipmentMovement: {
      props: {
        name: 'shipmentMovement',
        label: 'Shipment Movement Type',
        type: 'select',
        displayField: 'name',
        hasDefaultValue: true,
      },
      validation: {
        validationType: 'object',
        validations: [
        ],
      },
    },
  clearanceTotalValue: {
      props: {
        name: 'clearanceTotalValue',
        label: 'Total Value',
        type: 'number',
        inputProps: {
          min: 0,
          max: 99999999,
        }
      },
      validation: {
        name: 'clearanceTotalValue',
        validationType: 'number',
        validations: [
          {
            type: 'min',
            params: [0.01, 'Total value cannot be less than 0.01'],
          },
          {
            type: 'max',
            params: [99999999.99, 'Total value should be 99999999.99 or less'],
          },
        ],
      },
       // Add a custom validation to handle empty strings
       validate: value => {
        if (value === '') {
          return undefined; // No error if the value is an empty string
        }
      return value >= 0.01 && value <= 99999999.99 ? undefined : 'Invalid value';
      }
    },
    clearanceDescriptionOfGoods: {
      props: {
        name: 'clearanceDescriptionOfGoods',
        label: 'Description of goods (shipment level)',
        type: 'text',
        inputProps: {
          maxLength: 90,
        },
      },
      validation: {
        name: 'clearanceDescriptionOfGoods',
        validationType: 'string',
        validations: [
          {
            type: 'max',
            params: [90, 'Max 90 characters are allowed'],
          },
          {
            type: 'min',
            params: [3, 'Minimum of 3 characters are required'],
          },
          {
            type: 'matches',
            params: [/(.*[a-zA-Z0-9$&+,:;=?@#|'<>.^*()%!-]){3}/i, 'Minimum 3 non blank characters are required'],
          },
        ],
      },
    },
    shippingCharges: {
      props: {
        name: 'shippingCharges',
        label: 'Shipping Charges',
        type: 'number',
        inputProps: {
          min: 0,
          max: 99999999,
        },
      },
      validation: {
        name: 'shippingCharges',
        validationType: 'number',
        validations: [
          {
            type: 'max',
            params: [99999999.99, 'Shipping charges must be 99999999.99 or less'],
          },
        ],
      },
      // Add a custom validation to handle empty strings
    validate: value => {
      if (value === '') {
      return undefined; // No error if the value is an empty string
    }
    return value >= 0 && value <= 99999999.99 ? undefined : 'Invalid value';
  }
    },
    reasonExport: {
      props: {
        name: 'reasonExport',
        label: 'Reason For Export',
        type: 'select',
        displayField: 'name',
        hasDefaultValue: true,
      },
      validation: {
        validationType: 'object',
      },
    },

      commodityCode: {
          props: {
            name: 'commodityCode',
            label: 'Commodity code',
            type: 'text',
            inputProps: {
              maxLength: 10,
            },
            class_Name: 'commodity_Code',
          },
          validation: {
            validationType: 'string',
            validations: [
              {
                type: 'matches',
                params: [/^[0-9]{10}$/, 'Commodity code should be a 10 digit number'],
              },
              {
                type: 'max',
                params: [10, 'Commodity code should be a 10 digit number'],
              },
            ],
          },
        },
        quantity: {
          props: {
            name: 'quantity',
            label: 'UnitQuantity',
            type: 'number',
            inputProps: {
              max: 999,
              min: 1,
            },
          },
          validation: {
            validationType: 'number',
            name: 'quantity',
            validations: [
              {
                type: 'max',
                params: [999, 'Quantity must be 999 or less'],
              },
              {
                type: 'integer',
                params: ['Quantity should be a whole number'],
              },
            ],
          },
        },
        unitWeight: {
          props: {
            name: 'unitWeight',
            label: 'UnitWeight',
            type: 'number',
            inputProps: {
              max: 999,
              min: 1,
            },
          },
          validation: {
            validationType: 'number',
            name: 'unitWeight',
            validations: [
              {
                type: 'max',
                params: [999, 'unitWeight must be 999 or less'],
              },
              {
                type: 'integer',
                params: ['unitWeight should be a whole number'],
              },
            ],
          },
        },
        unitValue: {
          props: {
            name: 'unitValue',
            label: 'UnitValue',
            type: 'number',
            inputProps: {
              max: 999,
              min: 1,
            },
          },
          validation: {
            validationType: 'number',
            name: 'unitValue',
            validations: [
              {
                type: 'max',
                params: [999, 'unitValue must be 999 or less'],
              },
              {
                type: 'integer',
                params: ['unitValue should be a whole number'],
              },
            ],
          },
        },
        countryOfOrigin: {
          props: {
            name: 'countryOfOrigin',
            label: 'Country of origin',
            type: 'select',
            displayField: 'name',
          },
          validation: {
            validationType: 'object',
            name: 'countryOfOrigin',
          },
    },
    clearanceItemData: {
      props: {
        name: 'clearanceItemData',
        type: 'array',
        fields: {
          commodityCode: 'text',
          fullDescriptionOfGoods: 'text',
          weight: 'number',
          quantity: 'number',
          unitValue: 'number',
          countryOfOrigin: 'text',
        },
      },
      values: [],
      validation: {
        name: 'clearanceItemData',
        validationType: 'array',
        validations: [],
      },
    },
  },
};

export default collectionsDefaultsForm;
